<template>
  <div>
    <v-form ref="creditBookForm">
      <v-row>
        <v-col cols="12" md="12">
          <p class="text-h6">Tipo de CreditBook</p>
        </v-col>
        <v-col class="mt-n5" cols="12" md="12">
          <v-text-field v-model="data.nm" :rules="rules.requerido" label="Nombre" outlined dense
            required></v-text-field>
        </v-col>
        <v-col class="mt-n5" cols="12" md="12">
          <v-autocomplete v-model="data.mp" item-value="id" item-text="Nombre" :items="creditBooksMp"
            :rules="rules.requerido" label="Metodo Pago" outlined dense required></v-autocomplete>
        </v-col>
      </v-row>
      <div class="text-right">
        <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
        <v-btn style="margin-left: 6px" color="success" large @click="checkForm">Guardar</v-btn>
      </div>
    </v-form>
  </div>
</template>

<style scoped></style>

<script>
import CreditBookType from "../../clases/CreditBooks/CreditBookType.js";
import { mapGetters } from "vuex";
export default {
  name: "CreditBooksTypeForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      monedas: [],
      auxClienteId: "",
      data: CreditBookType.getPropertyModel(),
      rules: {
        requerido: [(value) => !!value || "El campo es requerido"],
        requeridoNumero: [(value) => Number(value) >= 0 || "El campo es requerido"],

      },
    };
  },
  computed: {
    ...mapGetters(["getPDVPagosTipos", "getPDVMonedasLista"]),
    creditBooksMp() {
      const cbmp = this.$pgsHelper.filterBy(this.getPDVPagosTipos, "Dnrele", true)
      return cbmp
    }
  },
  methods: {


    checkForm() {
      if (this.$refs.creditBookForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.data;
      dataSave.cnt = Number(dataSave.cnt);
      dataSave.Tenant = this.$store.getters.getFirebaseApp.tenant
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    if (this.edit) {

      const cbmodel = new CreditBookType(this.dataEdit)
      console.log(cbmodel)
      this.data = cbmodel.properties
    }
  },
};
</script>
